import { useCallback, useState } from "react"

export type AsyncError = (error: string) => void

// https://medium.com/trabe/catching-asynchronous-errors-in-react-using-error-boundaries-5e8a5fd7b971
// https://github.com/facebook/react/issues/14981
export const useAsyncError = (): AsyncError => {
  const [, setError] = useState()

  return useCallback(
    (error) => {
      setError(() => {
        throw new Error(error)
      })
    },
    [setError],
  )
}
